function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "basket_svg__bcc180c6-a5bf-4ed7-b16d-5e405500ec7b",
  d: "M9.95 60.89h44.1l-1.58-41.46H11.53L9.95 60.89zM21.12 14.79a11.68 11.68 0 0123.36 0"
});

function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iYWQ2YjE1ZmUtN2U1YS00MjM3LTg4Y2MtZTk0ZDY3ZTBlZTEwIiBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+YmFza2V0PC90aXRsZT48cG9seWdvbiBjbGFzcz0iYmNjMTgwYzYtYTViZi00ZWQ3LWIxNmQtNWU0MDU1MDBlYzdiIiBwb2ludHM9IjkuOTUgNjAuODkgNTQuMDUgNjAuODkgNTIuNDcgMTkuNDMgMTEuNTMgMTkuNDMgOS45NSA2MC44OSIvPjxwYXRoIGNsYXNzPSJiY2MxODBjNi1hNWJmLTRlZDctYjE2ZC01ZTQwNTUwMGVjN2IiIGQ9Ik0yMS4xMiwxNC43OWExMS42OCwxMS42OCwwLDAsMSwyMy4zNiwwIi8+PC9zdmc+";
export { SvgBasket as ReactComponent };